var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Button } from '../components';
export var Header = React.memo(function (_a) {
    var title = _a.title;
    return (_jsxs("div", __assign({ className: "chat-app-header" }, { children: [_jsx("div", { children: title }), _jsx(Button, { buttonType: "close" })] })));
});
